import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのPlacesロゴアイコン
 */
export function ProductLogoSmallPlaces({
  size = 20,
  color = "#25506B",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_966_14898)">
        <path
          d="M3.85339 10.5148C3.85339 10.5066 3.84676 10.5 3.83859 10.5C3.4012 10.5 3.01457 10.7842 2.88411 11.2017L1.00911 17.2017C0.80788 17.8457 1.28895 18.5 1.96359 18.5H18.2432C18.9178 18.5 19.3989 17.8457 19.1977 17.2017L17.3227 11.2017C17.1922 10.7843 16.8056 10.5 16.3682 10.5C16.36 10.5 16.3534 10.5066 16.3534 10.5148V13.078C16.3534 13.1118 16.3585 13.1453 16.3686 13.1775L17.4279 16.5672C17.495 16.7819 17.3346 17 17.1097 17H3.09708C2.8722 17 2.71184 16.7819 2.77892 16.5672L3.83822 13.1775C3.84828 13.1453 3.85339 13.1118 3.85339 13.0781V10.5148Z"
          fill={color}
        />
        <path
          d="M6.4744 15.1651L3.20501 17.0679C2.76368 17.3247 2.94588 18 3.45651 18H14.669C15.2563 18 15.3627 17.1628 14.7941 17.0159L7.22754 15.0611C6.9726 14.9953 6.70198 15.0326 6.4744 15.1651Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.8534 1.5C8.30111 1.5 7.8534 1.94772 7.8534 2.5V4.5H5.8534C5.30111 4.5 4.8534 4.94772 4.8534 5.5V13C4.8534 13.5523 5.30111 14 5.8534 14H8.8534V12.3333C8.8534 12.1492 9.00264 12 9.18673 12H11.0201C11.2042 12 11.3534 12.1492 11.3534 12.3333V14H14.3534C14.9057 14 15.3534 13.5523 15.3534 13V8.5C15.3534 7.94772 14.9057 7.5 14.3534 7.5H12.3534V2.5C12.3534 1.94772 11.9057 1.5 11.3534 1.5H8.8534ZM9.68673 3C9.50264 3 9.3534 3.14924 9.3534 3.33333V4.16667C9.3534 4.35076 9.50264 4.5 9.68673 4.5H10.5201C10.7042 4.5 10.8534 4.35076 10.8534 4.16667V3.33333C10.8534 3.14924 10.7042 3 10.5201 3H9.68673ZM6.68673 6C6.50264 6 6.3534 6.14924 6.3534 6.33333V7.16667C6.3534 7.35076 6.50264 7.5 6.68673 7.5H7.52006C7.70416 7.5 7.8534 7.35076 7.8534 7.16667V6.33333C7.8534 6.14924 7.70416 6 7.52006 6H6.68673ZM6.3534 9.33333C6.3534 9.14924 6.50264 9 6.68673 9H7.52006C7.70416 9 7.8534 9.14924 7.8534 9.33333V10.1667C7.8534 10.3508 7.70416 10.5 7.52006 10.5H6.68673C6.50264 10.5 6.3534 10.3508 6.3534 10.1667V9.33333ZM9.68673 6C9.50264 6 9.3534 6.14924 9.3534 6.33333V7.16667C9.3534 7.35076 9.50264 7.5 9.68673 7.5H10.5201C10.7042 7.5 10.8534 7.35076 10.8534 7.16667V6.33333C10.8534 6.14924 10.7042 6 10.5201 6H9.68673ZM9.3534 9.33333C9.3534 9.14924 9.50264 9 9.68673 9H10.5201C10.7042 9 10.8534 9.14924 10.8534 9.33333V10.1667C10.8534 10.3508 10.7042 10.5 10.5201 10.5H9.68673C9.50264 10.5 9.3534 10.3508 9.3534 10.1667V9.33333ZM12.3534 9.33333C12.3534 9.14924 12.5026 9 12.6867 9H13.5201C13.7042 9 13.8534 9.14924 13.8534 9.33333V10.1667C13.8534 10.3508 13.7042 10.5 13.5201 10.5H12.6867C12.5026 10.5 12.3534 10.3508 12.3534 10.1667V9.33333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_966_14898">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.103516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
